import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ErrorsContext } from '../contexts/errors_context'
import { translateApiError } from '../lib/translate_api_error'

const Errors = () => {
  const { t } = useTranslation()

  const { errors, resetErrors } = useContext(ErrorsContext)

  if (errors.length === 0) return null

  return (
    <ul className="errors">
      {
        errors.map((error, i) => {
          const message = translateApiError(t, error.message)
          const details = error.errors
            ? translateApiError(t, error.errors)
            : ''

          return (
            <li key={ i }>
              { message ? <span className="message">{ message }</span> : null }
              { details ? <p className="problem">{ details }</p> : null }
              <button className="tool white" onClick={ () => { resetErrors?.(error) } }>{ t('errors.button_clear') }</button>
            </li>
          )
        })
      }
    </ul>
  )
}

export { Errors }
